<template>
  <div class="row-history">
    <el-container class="row-con row-previewOnline">
      <div class="m-previewOnline">
        <ul class="ul-previewOnline">
          <li v-for="(item,index) of onlineList" :key="item.id" :class="{ 'offline': !item.onlineStatus==1 }">
            <div class="inner">
              <div class="top">
                <div class="right">
                  <div class="status">
                    <span class="icon"></span>
                    <span class="value" v-if="item.onlineStatus==1">在线</span>
                    <span class="value" v-else>离线</span>
                  </div>
                  <el-dropdown trigger="click" placement="top-start" @command="handleCommand">
                    <span class="more icon-more">
                    </span>
                    <el-dropdown-menu slot="dropdown" class="g-dropdown">
                      <el-dropdown-item :command="index + '-' + 0">
                        <span class="icon icon01"></span>
                        <span class="name">运行状态</span>
                      </el-dropdown-item>
                      <el-dropdown-item :command="index + '-' + 1">
                        <span class="icon icon02"></span>
                        <span class="name">历史记录</span>
                      </el-dropdown-item>
                      <!-- <el-dropdown-item :command="index + '-' + 2">
                        <span class="icon icon03"></span>
                        <span class="name">预警信息</span>
                      </el-dropdown-item> -->
                      <el-dropdown-item :command="index + '-' + 3">
                        <span class="icon icon04"></span>
                        <span class="name">转场记录</span>
                      </el-dropdown-item>
                      <el-dropdown-item :command="index + '-' + 4">
                        <span class="icon icon05"></span>
                        <span class="name">设计参数</span>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
                <div class="left">
                  <!--@/assets/images/previewOnline/icon-list01.png -->
                  <div class="pic" :style="{'background-image': `url(${iconImg})`}">
                  </div>
                  <div class="type">{{ item.typeName || '' }}</div>
                  <div class="name">{{ item.name || '' }}</div>
                </div>
              </div>
              <div class="detail">
                <div class="item">
                  <h4>设备编号</h4>
                  <div class="value">{{ item.key || '' }}</div>
                </div>
                <div class="item">
                  <h4>开始时间</h4>
                  <div class="value">{{item.realtime|ofiltersPipe('startTime')}}</div>
                </div>
                <div class="item">
                  <h4>记录状态</h4>
                  <div class="value">{{item.realtime|ofiltersPipe('recordStatus')}}</div>
                </div>
                <div class="item">
                  <h4>喷浆状态</h4>
                  <div class="value">{{item.realtime|ofiltersPipe('nozzleStatus')}}</div>
                </div>
                <div class="item">
                  <h4>累计浆量</h4>
                  <div class="value">{{item.realtime|ofiltersPipe('totalSlurry')}}
                    <span>{{!item.realtime?'':item.realtime.totalSlurry!=null?'(L)':''}}</span>
                  </div>
                </div>
                <div class="item">
                  <h4>累计灰量</h4>
                  <div class="value">{{item.realtime|ofiltersPipe('totalAsh')}}
                    <span>{{!item.realtime?'':item.realtime.totalAsh!=null?'(kg)':''}}</span>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </el-container>
    <el-dialog :title="`设计参数-${selectItem.key}`" :visible.sync="centerDialogVisible" class="m-pop">
      <div class="m-params-edit">
        <div class="g-notifacition">
          <span class="icon"></span>
          <span class="value">设计参数只有管理员可以修改</span>
        </div>
        <el-form class="form" ref="form" :model="form">
          <el-form-item class="item">
            <el-col :span="24">
              <h3>工程名称</h3>
              <el-input v-model="form.projectName" placeholder="请输入工程名称"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item class="item">
            <el-col :span="12">
              <h3>施工单位</h3>
              <el-input v-model="form.worker" placeholder="请输入施工单位"></el-input>
            </el-col>
            <el-col :span="12">
              <h3>最短成桩时间(min)</h3>
              <el-input v-model="form.minPileTime" type="number" :min="0" placeholder="请输入最短成桩时间"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item class="item">
            <el-col :span="12">
              <h3>设计桩长(m)</h3>
              <el-input v-model="form.designDepth" type="number" :min="0" placeholder="请输入设计桩长"></el-input>
            </el-col>
            <el-col :span="12">
              <h3>水泥掺量(kg/m)</h3>
              <el-input v-model="form.designAsh" type="number" :min="0" placeholder="请输入水泥掺量"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item class="item">
            <el-col :span="12">
              <h3>桩间距(m)</h3>
              <el-input v-model="form.designPilePadding" type="number" :min="0" placeholder="请输入桩间距"></el-input>
            </el-col>
            <el-col :span="12">
              <h3>桩径(cm)</h3>
              <el-input v-model="form.pileWidth" type="number" :min="0" placeholder="请输入桩径"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item class="item">
            <el-col :span="12">
              <h3>设计提钻速度(cm/min)</h3>
              <el-input v-model="form.designUpSpeed" type="number" :min="0" placeholder="请输入设计提钻速度"></el-input>
            </el-col>
            <el-col :span="12">
              <h3>设计下钻速度(cm/min)</h3>
              <el-input v-model="form.designDownSpeed" type="number" :min="0" placeholder="请输入设计下钻速度"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item class="item submit">
            <el-col :span="24">
              <el-button class="btn submit-btn" type="primary" @click="onSubmit">保存</el-button>
              <el-button class="btn" @click="closePop('centerDialogVisible')">取消</el-button>
            </el-col>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <!-- 详情弹出框 -->
    <el-dialog :visible.sync="centerDialogVisible1" class="m-pop m-pop-detail" v-el-dialog-drag>
      <div slot="title" class="dialog-header">
        <div class="left">
          <gTabs @change="changeHandle" :current="tab2" :list="tab2List" />
        </div>
      </div>
      <div class="dialog-content">
        <div class="m-tab-table  m-tab-echartTable" v-show="tab2 === 0">
          <div class="m-pop-echart m-pop-echart-f01">
            <el-row class="row">
              <el-col :span="12" class="col">
                <div class="inner inner1">
                  <!-- <h2>状态信息</h2> -->
                  <div class="m-statusinfo">
                    <div class="top">
                      <h3>{{selectItem.name}}</h3>
                      <div>
                        <div class="info">
                          <!-- <div class="item">
                            <div class="tit">孔号</div>
                            <div class="value">{{pile.pileDescribe|pilefilter}}</div>
                          </div> -->
                          <div class="item">
                            <div class="tit">孔号</div>
                            <div v-if="pile.length==1" class="value">
                              {{ pile[0].pileDescribe || '' }}
                            </div>
                            <div v-if="pile.length==0" class="value">--</div>
                            <el-select v-if="pile.length>1" v-model="defaultpile" class=" btnpile">
                              <el-option v-for="item in pile" :key="item.index" :label="item.pileDescribe" :value="item.pileId">
                              </el-option>
                            </el-select>
                          </div>

                          <div class="item">
                            <div class="tit">设备编号</div>
                            <div class="value">{{selectItem.key}}</div>
                          </div>
                        </div>
                        <div class="status">
                          <ul class="ul-status">
                            <li :class="recordStatusClass">
                              <div class="btn">{{real.recordStatus|stafilters}}</div>
                            </li>
                            <li :class="nozzleStatusClass">
                              <div class="btn">{{real.nozzleStatus|nozzlestafilters}}</div>
                            </li>
                          </ul>
                        </div>
                        <div style="clear:both"></div>
                      </div>
                    </div>
                    <div class="bottom">
                      <div class="item">
                        <h3>开始时间</h3>
                        <div class="value">{{real.startTime|datafilters}}</div>
                      </div>
                      <div class="item">
                        <h3>孔号</h3>
                        <div class="value">{{real.pileDescribe}}</div>
                      </div>
                      <div class="item">
                        <h3>水灰比</h3>
                        <div class="value">{{real.waterAsh|numfilters(0)}}</div>
                      </div>
                      <div class="item">
                        <h3>灌浆模式</h3>
                        <div class="value">{{real.processMode|modefilters}}</div>
                      </div>
                      <div class="item">
                        <h3>参数模式</h3>
                        <div class="value">{{real.paramType|parfilters}}</div>
                      </div>
                      <div class="item">
                        <h3>灌浆方法</h3>
                        <div class="value">{{real.processMethod|metfilters}}</div>
                      </div>

                      <div class="item">
                        <p>持续时长</p>
                        <p class="value">{{real.lasttime|numfilters(0)}} 分钟</p>
                      </div>
                      <div class="item">
                        <p>峰值压力</p>
                        <p class="value">{{real.pressurePeak|numfilters}} Mpa</p>
                      </div>
                      <div class="item">
                        <p>累计浆量</p>
                        <p class="value">{{real.totGrout|numfilters}} L</p>
                      </div>
                      <div class="item">
                        <p>累计灰量</p>
                        <p class="value">{{real.totAsh|numfilters}} kg</p>
                      </div>
                      <div class="item">
                        <p>单位浆量</p>
                        <p class="value">{{real.perGrout|numfilters}} L</p>
                      </div>
                      <div class="item">
                        <p>单位灰量</p>
                        <p class="value">{{real.perAsh|numfilters}} kg</p>
                      </div>

                      <div class="item">
                        <p>注浆</p>
                        <p class="value">{{ real.flow|numfilters }} L/min</p>
                      </div>
                      <div class="item">
                        <p>进浆</p>
                        <p class="value">{{real.flowIn|numfilters}} L/min</p>
                      </div>
                      <div class="item">
                        <p>返浆</p>
                        <p class="value">{{real.flowOut|numfilters}} L/min</p>
                      </div>
                      <div class="item">
                        <p>压力</p>
                        <p class="value">{{real.pressure|numfilters}} Mpa</p>
                      </div>
                      <div class="item">
                        <p>密度</p>
                        <p class="value">{{real.density|numfilters}} g/cm³</p>
                      </div>
                    </div>
                  </div>
                </div>
              </el-col>
              <el-col :span="12" style="height:100%" class="col">
                <div class="inner">
                  <h2>注浆压力曲线</h2>
                  <div ref="myChart01" :style="{ width: '100%', height: '100%' }"></div>
                </div>
              </el-col>
            </el-row>
            <el-row class="row">
              <el-col :span="12" class="col">
                <div class="m-box m-map">
                  <div class="top">
                    <!-- <h2>电子地图</h2> -->
                    <!-- <div class="right">
                      <g-tabs @change="changeMapHandle" :current="mapType" :list="tabList" />
                    </div> -->
                  </div>
                  <div class="con">
                    <div class="mapDiv">
                      <tdt-map :center="coordinates.center" :zoom="coordinates.zoom" :controls="coordinates.controls">
                        <tdt-marker :position="coordinates.position" :icon="coordinates.icon" :draggable="coordinates.draggable"></tdt-marker>
                        <tdt-control position="topright" :visible="coordinates.visible"></tdt-control>
                      </tdt-map>
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="m-tab-table" v-show="tab2 == 1">
        </div>
        <div class="m-tab-table" v-show="tab2 == 2">
        </div>
        <div class="m-tab-table" v-show="tab2 == 3">
          <div class="block">
            <el-carousel trigger="click" :autoplay="false" arrow="never" class="swiper_video">
              <el-carousel-item v-for="(camera,index) in cameraLive" :key="index" class="swiper_item" :label="index+1">
                <video-player style="width:100%;height:100%" ref="videoPlayer" :options="playerOptions[index]"></video-player>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 页码 -->
    <el-footer class="m-selectAll">
      <div class="right">
        <el-pagination class="pages" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage4" :page-sizes="[4, 8, 12, 16]" :page-size="pageSize" layout="sizes,slot,  prev, pager, next" :total="total">
          <!-- slot部分，跳转首页 -->
          <button class="lastPage" @click="toFirstPage">
            <i class="el-icon-d-arrow-left"></i>
          </button>
        </el-pagination>

        <el-pagination class="pages" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage4" :page-sizes="[4, 8, 12, 16]" :page-size="pageSize" layout="slot , jumper" :total="total">
          <!-- slot部分，跳转末页 -->
          <button class="lastPage" @click="toLastPage">
            <i class="el-icon-d-arrow-right"></i>
          </button>
        </el-pagination>
      </div>
    </el-footer>
  </div>
</template>
<script>
import GPS from '../../utils/GpstoGD'
import { lastData, pileIds, datas, editConfig } from '@/api/api'
import * as echarts from "echarts"
import gTabs from "@/components/gTabs"
import $ from 'jquery'
import moment from "moment";
export default ({
  components: {
    gTabs
  },
  props: ['onlineList', 'iconImg', 'total', 'currentPage4', 'handleCurrentChange', 'handleSizeChange', 'pageSize', 'toLastPage', 'toFirstPage'],
  data() {
    return {
      defaultpile: '',
      coordinates: {
        center: [0, 0],
        zoom: 11,
        draggable: false,
        position: [0, 0],
        icon: require("@/assets/images/map/b3.png"),
        controls: [
          "Zoom",
          "Scale",
          {
            name: "MapType",
            position: "topright",
            mapTypes: [
              {
                title: "地图", //地图控件上所要显示的图层名称
                icon: "http://api.tianditu.gov.cn/v4.0/image/map/maptype/vector.png", //地图控件上所要显示的图层图标（默认图标大小 80x80）
                layer: "TMAP_NORMAL_MAP" //地图类型，在原天地图api中以window.TMAP_NORMAL_MAP表示，此处为字符串
              },
              {
                title: "卫星",
                icon: " http://api.tianditu.gov.cn/v4.0/image/map/maptype/satellite.png",
                layer: "TMAP_SATELLITE_MAP"
              },
            ]
          }
        ],
        visible: true,
        copyright: true
      },// 天地图
      cameraLive: [],
      playerOptions: [],
      message: String,
      index: 0,
      recordStatusClass: '',
      nozzleStatusClass: '',
      timer: null,
      deviceKey: '',
      pileId: '',
      pile: [],  //桩号
      real: {
        'recordStatus': 3,
        'startTime': 0,
        'xAngle': 0,
        'yAngle': 0,
      },
      flow: [], //【时间，流量】
      deep: [], //【时间，深度】
      selectItem: [],
      ztTop: 0,//钻头位置
      y: 0.00,//钻头深度
      scale: 1,
      centerDialogVisible: false,
      form: {
        projectName: '',
        worker: '',
        minPileTime: '',
        designDepth: '',
        designAsh: '',
        designPilePadding: '',
        pileWidth: '',
        designUpSpeed: '',
        designDownSpeed: ''
      },
      centerDialogVisible1: false,
      tab2: 0,
      tab2List: [],
      ispileIds: true
    }
  },
  filters: {
    ofiltersPipe(val, val2) {
      if (!val) {
        return '-'
      } else {
        if (val[val2] == null) {
          return '-'
        } else {
          return val[val2]
        }
      }
    },
    pilefilter(val) {
      if (val == null) {
        return '--'
      } else {
        return val
      }
    },
    datafilters(val) {
      if (val == 0) {
        return '停止中'
      } else {
        return moment(val * 1000).format(' HH:mm:ss')
      }
    },
    numfilters(val, deg) {
      if (deg == undefined) {
        deg = 2
      }
      if (val == null) {
        return '-'
      } else {
        if (isNaN(val)) {
          //val 不是数字
          return val
        } else {
          //val是数字
          return parseFloat(val).toFixed(deg)
        }
      }
    },
    stafilters(val) {
      switch (val) {
        case 1:
          return '记录中'
        case 2:
          return '暂停'
        case 3:
          return '结束'
        case 0:
          return '结束'
        default:
          return val
      }
    },
    nozzlestafilters(val) {
      switch (val) {
        case 1:
          return '喷浆'
        default:
          return '止喷'
      }
    },
    parfilters(val) {
      if (val == 0) {
        return '二参数'
      } else if (val == 1) {
        return '三参数'
      } else if (val == 2) {
        return '四参数'
      } else {
        return '-'
      }
    },
    metfilters(val) {
      if (val == 0) {
        return '大循环'
      } else if (val == 1) {
        return '小循环'
      } else {
        return '-'
      }
    },
    modefilters(val) {
      if (val == 0) {
        return '灌浆施工记录'
      } else if (val == 1) {
        return '封孔施工记录'
      } else if (val == 2) {
        return '简易压水施工记录'
      } else if (val == 3) {
        return '单点压水施工记录'
      } else if (val == 4) {
        return '五点压水施工记录'
      } else if (val == 5) {
        return '裂隙压水施工记录'
      } else if (val == 6) {
        return '帷幕灌浆'
      } else if (val == 7) {
        return '固结灌浆'
      } else if (val == 8) {
        return '岩溶注浆'
      } else {
        return '-'
      }
    }
  },
  watch: {
    centerDialogVisible1(val, oldVal) {//普通的watch监听
      if (val == false) {
        if (this.timer) {
          clearInterval(this.timer)
        }
        this.getwatchData()
      }
    },
  },
  methods: {
    // watch中的数据变量
    getwatchData() {
      this.ispileIds = true
      this.flow = []
      this.deep = []
      this.pile = []
      this.defaultpile = ''
      if (this.myChart01 === undefined || this.myChart01._disposed) return
      this.myChart01.dispose() //监听弹出框在关闭时将flow和deep里边的数据都清空
    },
    initEchart01(show) {
      let option = {
        title: {
          show: show,
          text: "暂无数据",
          textStyle: {
            color: '#101D34',
            fontSize: 28
          },
          left: "center",
          top: 'center'
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          top: "3%",
          right: "10%",
          data: ["注浆", "压力"],
        },
        grid: {
          top: '22%',
          left: "4%",
          right: "4%",
          bottom: "13%",
          containLabel: true,
        },
        toolbox: {
          right: "3%",
          top: '3%',
          feature: {
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "time",
          axisLabel: {
            formatter: '{HH}:{mm}'
          }
        },
        yAxis: [
          {
            name: "注浆   ",
            type: "value",
            inverse: false,  //设置坐标轴翻转
            nameLocation: 'start',
            nameTextStyle: {
              padding: [10, 0, 0, 15]
            },
            // max: 150,
            axisLine: {
              show: true
            }
          },
          {
            name: "  压力",
            type: "value",
            inverse: false,
            nameLocation: 'start',
            max: 10,
            splitLine: {
              show: false
            },
            nameTextStyle: {
              padding: [10, 15, 0, 0]
            }
          },
        ],
        series: [
          {
            name: "注浆",
            type: "line",
            showSymbol: false,
            data: this.deep
          },
          {
            name: "压力",
            yAxisIndex: 1,
            type: "line",
            splitLine: {
              lineStyle: {
                type: "dashed",
              },
            },
            showSymbol: false,
            data: this.flow,
          },
        ],
      };
      // 基于准备好的dom，初始化echarts实例
      // this.myChart01 = echarts.init(this.$refs.myChart01, null, { renderer: 'svg' });
      // 绘制图表
      this.myChart01.setOption(option);
    },
    // 在线一览详情头部点击切换不同的模式
    changeHandle(index) {
      let self = this;
      this.tab2 = index;
      if (index == 0) {
        this.$nextTick(() => {
          // this.initEchart01();
          window.onresize = function () {
            self.myChart01.resize();
          };
        });
        this.getData()
      }
      if (index == 1) {
        sessionStorage['type'] = this.selectItem.type
        sessionStorage['deviceKey'] = this.selectItem.key
        this.$router.push('/history')
      }
      // if (index == 2) {
      //   sessionStorage['deviceKey'] = this.selectItem.key
      //   this.$router.push('/alertInfo')
      // }
      if (index == 2) {
        clearInterval(this.timer)
        this.getwatchData()
      }
    },
    // getPileIds获取实时桩号
    getPileIds() {
      pileIds(this.selectItem.key).then(res => {
        if (res != null) {
          this.pile = res
          let flag = true
          for (var i = 0; i < this.pile.length; i++) {
            if (this.defaultpile == this.pile[i].pileId) {
              this.defaultpile = this.pile[i].pileId
              this.ispileIds = false
              flag = false
            }
          }
          if (flag) {
            this.defaultpile = this.pile[0].pileId
            this.ispileIds = false
          }
        }
        // if (res != null) {
        //   this.pile = res
        //   this.ispileIds = false
        // }
      })
    },
    // data获取实时数据
    getData() {
      datas(this.selectItem.key, this.defaultpile, 'realTime,pressure,flow').then(res => {
        const loading = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        for (var i = 0; i < res.length; i++) {
          let day_Time = moment(res[i].realTime * 1000).format('YYYY-MM-DD HH:mm:ss')
          let pressureTime = [];
          let totGroutTime = [];
          pressureTime.push(day_Time, res[i].pressure.toFixed(2))
          totGroutTime.push(day_Time, res[i].flow.toFixed(2))
          this.flow.push(pressureTime)
          this.deep.push(totGroutTime)
        }
        // 基于准备好的dom，初始化echarts实例
        this.myChart01 = echarts.init(this.$refs.myChart01, null, { renderer: 'svg' });
        this.initEchart01(false);
        this.timer = setInterval(() => {
          lastData(this.selectItem.key, this.defaultpile).then(res => {
            if (res != null) {
              this.real = res
              if (this.ispileIds == true) {
                this.getPileIds()
              }
              if (this.real.recordStatus == '1') {
                this.recordStatusClass = 'on'
              } else if (this.real.recordStatus == '2') {
                this.recordStatusClass = 'pause'
              } else if (this.real.recordStatus == '3') {
                this.recordStatusClass = ''
                this.ispileIds = true
              }
              // this.nozzleStatusClass='on'
              if (this.real.nozzleStatus == 1) {
                this.nozzleStatusClass = 'on'
              } else {
                this.nozzleStatusClass = ''
              }
              let realDayTime = moment(res.realTime * 1000).format('YYYY-MM-DD HH:mm:ss')
              if (this.flow.length != 0 || this.flow[this.flow.length - 1][0] != realDayTime) {
                if (this.flow[this.flow.length - 1][0] != realDayTime) {
                  let realpressureTime = [];
                  let realtotGroutTime = [];
                  realpressureTime.push(realDayTime, res.pressure.toFixed(2))
                  realtotGroutTime.push(realDayTime, res.flow.toFixed(2))
                  this.flow.push(realpressureTime)
                  this.deep.push(realtotGroutTime)
                  this.initEchart01(false)
                }
              }
              this.real.lasttime = ((res.realTime - res.startTime) / 60).toFixed(0)
            } else {
              this.ispileIds = true
              this.flow = []
              this.deep = []
              this.defaultpile = ''
              this.initEchart01(true);
            }
            loading.close()
          })
        }, 3000);
        setTimeout(() => {
          loading.close();
        }, 6000);
      })
    },
    // 点击弹出页面
    handleCommand(command) {
      let self = this;
      let index = command.split('-')[0];
      let index2 = command.split('-')[1];
      this.selectItem = this.onlineList[index]; //将具体点击的字段数据存储在selectItem中
      this.cameraLive = JSON.parse(this.selectItem.cameraLive);
      if (this.cameraLive == null) {
        this.tab2List = [
          {
            name: "运行状况",
          },
          {
            name: "历史记录",
          }
        ]
      } else {
        this.tab2List = [
          {
            name: "运行状况",
          },
          {
            name: "历史记录",
          }, {
            name: "实时监控",
          }
        ]
        this.playerOptions = [];
        for (let i = 0; i < this.cameraLive.length; i++) {
          let playerOption = {
            playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
            autoplay: true, //如果true,浏览器准备好时开始回放。
            muted: false, // 默认情况下将会消除任何音频。
            loop: false, // 导致视频一结束就重新开始。
            preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
            language: 'zh-CN',
            aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
            fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
            sources: [{
              type: "application/x-mpegURL",//这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
              src: this.cameraLive[i].liveUrl //url地址
            }],
            notSupportedMessage: '此视频暂无法播放,请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
            controlBar: {
              timeDivider: true,
              durationDisplay: true,
              remainingTimeDisplay: false,
              fullscreenToggle: true  //全屏按钮
            }
          }
          this.playerOptions.push(playerOption)
        }
      }

      if (this.selectItem.position == '') {
        this.selectItem.position = '0,0'
      } else {
        this.coordinates.position = [this.selectItem.position.split(',')[0], this.selectItem.position.split(',')[1]]
        this.coordinates.center = [this.selectItem.position.split(',')[0], this.selectItem.position.split(',')[1]]
        if (this.selectItem.onlineStatus == 0) {
          this.coordinates.icon = require("@/assets/images/map/b3.png")
        } else {
          this.coordinates.icon = require("@/assets/images/map/a3.png")
        }
      }
      // datas获取实时数据列表
      switch (index2) {
        case '0': {
          this.centerDialogVisible1 = true;
          this.$nextTick(() => {
            // this.initEchart01();
            window.onresize = function () {
              self.myChart01.resize();
            };
          });
          // pileIds正在施工桩号
          this.getPileIds()
          this.getData()
          break;
        }
        case '1': {
          // console.log('灌浆info实时跳转');
          sessionStorage['type'] = this.selectItem.type
          sessionStorage['deviceKey'] = this.selectItem.key
          this.$router.push('/history')
          break;
        }
        case '2': {
          sessionStorage['deviceKey'] = this.selectItem.key
          this.$router.push('/alertInfo')
          break;
        }
        case '3': {
          this.$router.push('/previewOnline#')
          break;
        }
        case '4': {
          this.centerDialogVisible = true;
          this.form.projectName = JSON.parse(this.selectItem.content).projectName == undefined ? '' : JSON.parse(this.selectItem.content).projectName
          this.form.worker = JSON.parse(this.selectItem.content).worker == undefined ? '' : JSON.parse(this.selectItem.content).worker
          this.form.minPileTime = JSON.parse(this.selectItem.content).minPileTime == undefined ? '' : JSON.parse(this.selectItem.content).minPileTime
          this.form.designDepth = JSON.parse(this.selectItem.content).designDepth == undefined ? '' : JSON.parse(this.selectItem.content).designDepth
          this.form.designAsh = JSON.parse(this.selectItem.content).designAsh == undefined ? '' : JSON.parse(this.selectItem.content).designAsh
          this.form.designPilePadding = JSON.parse(this.selectItem.content).designPilePadding == undefined ? '' : JSON.parse(this.selectItem.content).designPilePadding
          this.form.pileWidth = JSON.parse(this.selectItem.content).pileWidth == undefined ? '' : JSON.parse(this.selectItem.content).pileWidth
          this.form.designUpSpeed = JSON.parse(this.selectItem.content).designUpSpeed == undefined ? '' : JSON.parse(this.selectItem.content).designUpSpeed
          this.form.designDownSpeed = JSON.parse(this.selectItem.content).designDownSpeed == undefined ? '' : JSON.parse(this.selectItem.content).designDownSpeed
          break;
        }
        // default: {

        // }
      }
    },
    destroyed() {
      if (this.timer) {
        clearInterval(this.timer)
      }
    },
    // 保存设计参数
    onSubmit() {
      editConfig(this.form, this.selectItem.id).then((res) => {
        this.onlineList[this.index].content = JSON.stringify(this.form)
      })
      this.centerDialogVisible = false;
    },
    // 取消关闭设计参数
    closePop(name) {
      this[name] = false;
    },
    // 钻头
    myFun(y) {
      var that = this;
      that.y = Number(y).toFixed(2);
      that.ztTop = (100 - y / 40 * 100) + '%';
    },
  }
})
</script>
<style scoped>
/* 双头按钮样式 */
.btnpile {
  width: 150px;
}
.ul-status li {
  margin-left: 2rem;
}
.el-col-12[data-v-20d715d5] {
  width: 100%;
}
.mapDiv {
  height: 100%;
  width: 100%;
}
/* .m-pop-echart .col,
.m-tab-echartTable {
  height: auto;
} */

.m-pop-echart .row {
  display: flex;
}

.m-box {
  height: 100%;
  padding-top: 1.25rem;
}

.m-pop-echart-f01 .inner1 {
  padding: 20px 32px 0;
}
/* 在线一览 状态信息底部的列表中每个元素宽度 */
.m-statusinfo .bottom .item:first-child {
  width: 20%;
}
.m-statusinfo .bottom .item:nth-child(2),
.m-statusinfo .bottom .item:nth-child(3) {
  width: 15%;
}
.m-statusinfo .bottom .item:nth-child(13),
.m-statusinfo .bottom .item:nth-child(14),
.m-statusinfo .bottom .item:nth-child(15),
.m-statusinfo .bottom .item:nth-child(16),
.m-statusinfo .bottom .item:nth-child(17) {
  width: 20%;
}
.m-statusinfo .bottom .item {
  width: 16.58%;
  padding-bottom: 5px;
  border-bottom: 1px solid #cfcece;
}
/* 在线一览 状态信息底部的列表中每个元素宽度结束 */
/* 在线一览 状态信息底部的列表中每个元素宽度 */
.m-pop-echart .col[data-v-20d715d5],
.m-tab-echartTable[data-v-20d715d5] {
  height: 100%;
}
.el-col-12 {
  /* 在线一览 详情底部地图宽度 */
  width: 100%;
}
.m-statusinfo .bottom {
  padding: 1.25rem 0 1rem;
}
.m-pop-echart .col {
  padding: 0.15rem 0.15rem;
}
</style>
